<template>
  <b-row>
    <b-col cols="12">
      <field-content />
    </b-col>
  </b-row>
</template>

<script>
import { BRow, BCol } from 'bootstrap-vue'
import FieldContent from './FieldContent.vue'

export default {
  components: {
    BRow,
    BCol,

    FieldContent
  },
}
</script>

<style lang="scss" >
@import '@core/scss/vue/libs/vue-good-table.scss';
</style>